import * as React from 'react';

interface INewbuildingBrokerModalsContext {
  loadingPlace: TOpeningPlace | null;
  startMicrofrontOpening: (place: TOpeningPlace) => void;
}

export type TOpeningPlace = 'bookingBanner' | 'bookingLabel' | 'fallbackModal';

/* istanbul ignore next */
export const NewbuildingBrokerModalsContext = React.createContext<INewbuildingBrokerModalsContext>({
  loadingPlace: null,
  startMicrofrontOpening: () => {},
});
